import { Datacenter } from '@datadog/browser-core';
import { datadogRum } from '@datadog/browser-rum';

import useEffectOnce from 'hooks/use-effect-once';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import {
  brand,
  env,
  getConfigValue,
  isLocalDev,
  platform,
  releaseTimestamp,
} from 'utils/environment';

// initializes monitoring on the window.DD_RUM global
// once started, DD_RUM sessions cannot be reconfigured
const useDatadogRUM = () => {
  const dataDogConfig = getConfigValue('datadog');
  const sampleRate = useFlag(LaunchDarklyFlag.DATADOG_RUM_SAMPLE_RATE);
  const applicationId = dataDogConfig.rum.applicationId;
  const clientToken = dataDogConfig.rum.clientToken;
  const datacenter = (dataDogConfig.rum.dataCenter as Datacenter) || 'us';

  useEffectOnce(() => {
    const defaultRate = isLocalDev ? 100 : 0;
    datadogRum.init({
      applicationId,
      clientToken,
      datacenter,
      env: env(),
      service: `${brand()}_${platform()}`,
      version: releaseTimestamp(),
      sampleRate: typeof sampleRate === 'number' ? sampleRate : defaultRate,
    });
  });
};

export default useDatadogRUM;
